import * as React from 'react';

import { App, Button, Modal, Typography } from 'antd';

import { CHECKOUT_ELEMENTS_URL } from 'settings';
import type { ProductOffer } from 'v2/interfaces/product';

import { Icon } from '@eduzz/ui-antd-theme';

import { PricesList } from './PricesList';

type LinksModalProps = {
  isOpen: boolean;
  closeModal: () => void;
  offer: ProductOffer;
};

function LinksModal({ isOpen, closeModal, offer }: LinksModalProps) {
  const { message } = App.useApp();

  function mountOfferLink(offer: ProductOffer) {
    return `${CHECKOUT_ELEMENTS_URL}/${offer.key}`;
  }

  function copyLinkToClipboard(link: string) {
    navigator.clipboard.writeText(link);
    message.success('Link copiado para a área de transferência');
  }

  const offerLink = mountOfferLink(offer);

  return (
    <Modal
      open={isOpen}
      onCancel={closeModal}
      width={700}
      title='Links da oferta'
      footer={
        <div className='flex justify-end'>
          <Button type='text' onClick={closeModal}>
            Fechar
          </Button>
        </div>
      }
    >
      <div className='flex flex-col gap-4'>
        <Typography.Text strong id='links-modal-offer-name'>
          {offer.name}
        </Typography.Text>

        <div className='flex flex-col gap-2 rounded-(--uizz-antd-border-radius-lg) bg-(--uizz-antd-color-fill-tertiary) p-4'>
          <Typography.Text type='secondary'>Página de pagamento (Eduzz Checkout Elements)</Typography.Text>
          <div className='flex items-center gap-2 rounded-(--uizz-antd-border-radius) border border-(--uizz-antd-color-border) bg-(--uizz-antd-color-bg-container) px-3 py-2'>
            <Icon.Link size={16} className='shrink-0 text-(--uizz-antd-color-text-secondary)' />
            <Typography.Link
              className='min-w-0 flex-1 truncate'
              id='links-modal-offer-link'
              href={offerLink}
              target='_blank'
              rel='noreferrer'
            >
              {offerLink}
            </Typography.Link>
            <Button
              type='text'
              shape='circle'
              id='links-modal-copy-button'
              aria-label='Copiar link'
              icon={<Icon.Copy size={16} />}
              onClick={() => copyLinkToClipboard(offerLink)}
            />
          </div>
        </div>

        {offer.prices?.length > 0 && <PricesList offer={offer} />}
      </div>
    </Modal>
  );
}

export { LinksModal };
